import React from "react";
import TableHeader from "./tableHeader";
import TableBody from "./tableBody";

const Table = ({ columns, sortColumn, onSort, data, noInfo, footer }) => {
  return (
    <table className="table table-bordered flex-nowrap app-table">
      <TableHeader columns={columns} sortColumn={sortColumn} onSort={onSort} noInfo={noInfo}/>
      <TableBody  columns={columns} data={data} />
      {footer ? <tfoot>{footer}</tfoot> : null}
    </table>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/common/table.jsx